document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);
    const currentAnimalParams = params.get('animal')?.toLocaleLowerCase(); 
    const allBreedersFilter = document.getElementById('all-breeders-filter');

    const animalFilters = document.querySelectorAll('.animal-filter__btn');
    /** @type {NodeListOf <HTMLElement>} */
    const breederCards = document.querySelectorAll('.breeders-cards__container');  

    if ( params.has('animal')) {
        allBreedersFilter.classList.remove('text--underlined');
        allBreedersFilter.classList.remove('link--animated')
    } else {
        allBreedersFilter.classList.add('text--underlined');
        allBreedersFilter.classList.add('link--animated')
    }

    animalFilters.forEach(filter => {
        const filterName = filter.textContent.trim().toLowerCase();

        if (params.get('animal') === filterName) {
            filter.classList.add('text--underlined');
            filter.classList.add('link--animated');
        } else {
            filter.classList.remove('text--underlined');
            filter.classList.remove('link--animated');
        }
    }) 

    breederCards.forEach(card => {
        const animalType = card.dataset.animalType.toLowerCase();
        const shouldDisplayCard = !currentAnimalParams || animalType === currentAnimalParams;

        const breedersInfoMinusIcon = card.querySelector('.breeders-more-info__close');
        const breedersInfoPlusIcon = card.querySelector('.breeders-more-info__open');
        const breederInfoContainer = card.querySelector('.breeder-contact__info');

        //if the animalType equals the animal in the URL params, display the card, else, hide the card
        card.style.display = shouldDisplayCard ? 'flex' : 'none';

        breedersInfoPlusIcon.addEventListener('click', () => {
            breedersInfoPlusIcon.style.display = 'none';
            breedersInfoMinusIcon.style.display = 'flex';
            breederInfoContainer.style.display = 'block';
        });

        breedersInfoMinusIcon.addEventListener('click', () => {
            breedersInfoMinusIcon.style.display = 'none';
            breedersInfoPlusIcon.style.display = 'flex';
            breederInfoContainer.style.display = 'none';
        });
    })
})